import { render, staticRenderFns } from "./pubtravel.vue?vue&type=template&id=043a6074&scoped=true&"
import script from "./pubtravel.vue?vue&type=script&lang=js&"
export * from "./pubtravel.vue?vue&type=script&lang=js&"
import style0 from "./pubtravel.vue?vue&type=style&index=0&id=043a6074&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043a6074",
  null
  
)

export default component.exports